import React, { useState } from "react";

const Datefilter = ({ onFilter }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showFilter, setShowFilter] = useState(false);

  const handleFilter = () => {
    if (onFilter) {
      onFilter({ fromDate, toDate });
    }
    setShowFilter(false);
  };

  return (
    <div className="relative inline-block">
      <button
        onClick={() => setShowFilter(!showFilter)}
        className="bg-white py-2 px-6 font-bold hover:bg-gray-100 text-gray-800 border border-gray-400 rounded shadow-md"
      >
        Filter
      </button>

      {showFilter && (
        <div className="absolute top-12 right-0 bg-white shadow-xl rounded-md p-4 w-96 border border-secondary-300">
          <h1 className="text-xl font-bold">Filter Report</h1>
          <hr className="text-secondary-200 mt-2 mb-2"></hr>
          <div>
            <label className="block text-md font-medium text-secondary-700">
              From Date:
            </label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-full p-2 border border-secondary-200 rounded-md mb-2"
            />

            <label className="block text-md font-medium  text-secondary-700">
              To Date:
            </label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="w-full p-2 border  border-secondary-200 rounded-md mb-3"
            />

            <button
              onClick={handleFilter}
              className="bg-[#4F9CF9] text-white w-full py-2 rounded-md hover:bg-[#45fa4e] transition"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Datefilter;
